import { render, staticRenderFns } from "./EditorSurvey.vue?vue&type=template&id=01e945c6"
import script from "./EditorSurvey.vue?vue&type=script&lang=js"
export * from "./EditorSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports